import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import timing from '../../client/middleware/timing'
import macmillan from '../../client/middleware/macmillan'
import loggly from '../../client/middleware/loggly'
import analytics from '../../client/middleware/analytics'
import { createLogger } from 'redux-logger'

import rootReducer from '../reducers'
import { responsiveStoreEnhancer } from 'redux-responsive'

export let store

export default function configure (initialState) {
  const create = window.devToolsExtension && process.env.NODE_ENV !== 'production'
    ? window.devToolsExtension()(createStore)
    : createStore

  const middleware = [
    thunk,
    macmillan,
    timing,
    analytics,
    loggly
  ]

  if (process.env.NODE_ENV !== 'production') {
    middleware.push(createLogger({ collapsed: true }))
  }

  const createStoreWithMiddleware = compose(responsiveStoreEnhancer, applyMiddleware(...middleware))(create)
  store = createStoreWithMiddleware(rootReducer, initialState)

  if (module.hot) {
    module.hot.accept('../reducers', () => {
      const nextReducer = require('../reducers')
      store.replaceReducer(nextReducer)
    })
  }

  return store
}
